import React from 'react';
import { colors } from '../../web-polyfills/native-app-theme/colors';
import { ui } from '../../web-polyfills/native-app-theme/ui';
import type { ContentItem } from '../../models/ContentManagementInterface';
import { usePreviewResolvedImages } from './mobileAppPreviewImages';

/** One fund update as the app shows it: its date label and its content blocks. */
export interface MobileAppFundUpdate {
  id?: string;
  dateLabel?: string;
  content: ContentItem[];
}

interface FundUpdateCardsProps {
  updates: MobileAppFundUpdate[];
  contentWidth: number;
  ContentManagementRenderer: React.ComponentType<any>;
  ScreenSectionTitle: React.ComponentType<any>;
}

function FundUpdateCard({
  update,
  contentWidth,
  ContentManagementRenderer,
  ScreenSectionTitle,
}: Omit<FundUpdateCardsProps, 'updates'> & { update: MobileAppFundUpdate }) {
  const resolvedContent = usePreviewResolvedImages(update.content);
  return (
    <div style={{ backgroundColor: colors.surface, borderRadius: ui.cardRadius, padding: '16px' }}>
      <ScreenSectionTitle>Project update</ScreenSectionTitle>
      {update.dateLabel && (
        <div style={{ fontSize: 12, color: colors.textSecondary, marginBottom: 12 }}>
          {update.dateLabel}
        </div>
      )}
      <ContentManagementRenderer content={resolvedContent as any} contentWidth={contentWidth} />
    </div>
  );
}

/** The app's fund update cards, one per update, in the order given (newest first). */
export default function MobileAppFundUpdateCards({ updates, ...cardProps }: FundUpdateCardsProps) {
  if (updates.length === 0) {
    return <div style={{ color: colors.textSecondary, fontSize: 14 }}>No updates yet.</div>;
  }
  return (
    <>
      {updates.map((update, index) => (
        <FundUpdateCard
          key={update.id ?? `${update.dateLabel}-${index}`}
          update={update}
          {...cardProps}
        />
      ))}
    </>
  );
}
